module.exports = __webpack_public_path__ + "img/faux-carousel-blocks@3x.4597ec66.png";